/* ------------- CONFIGURAR ------------ */
const COMPANY_ID = 'Q6NSda';   // Site ID
const LIST_ID    = 'SciRNY';   // List ID Coming-Soon
/* ------------------------------------- */

document.addEventListener('DOMContentLoaded', () => {
    const trigger = document.getElementById('bis-cs-trigger');
    const modal   = document.getElementById('bis-cs-modal');
    if (!trigger || !modal) return;

    const overlay = modal.querySelector('.bis-cs-overlay');
    const close   = modal.querySelector('.bis-cs-close');
    const form    = document.getElementById('bis-cs-form');
    const toast   = document.getElementById('bis-cs-toast');
    const panel   = document.getElementById('bis-cs-panel');
    let opening   = false;
    let closing   = false;
    const DURATION = 300;

    function openModal(){
        if (opening || closing) return;
        opening = true;

        panel.classList.remove('bis-cs-closing');
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden','false');

        /*  reset opening después de 300 ms  */
        setTimeout(()=> opening = false, DURATION + 20);
    }

    function closeModal(){
        if (closing || opening) return;
        closing = true;

        panel.classList.add('bis-cs-closing');

        setTimeout(()=>{
            panel.classList.remove('bis-cs-closing');
            modal.classList.remove('bis-slide-out','is-active');
            modal.setAttribute('aria-hidden','true');
            closing = false;
        }, 300);   // igual a .25s en CSS (+50 ms de margen)
    }


    trigger.addEventListener('click', openModal);
    close  .addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
    document.addEventListener('keyup', e => e.key === 'Escape' && closeModal());

    form.addEventListener('submit', async (ev) => {
        ev.preventDefault();

        const email = document.getElementById('bis-cs-email').value.trim();
        if (!email) return;

        // 👉 lee el CSV de variantes y toma como máximo 4
        const raw = (document.getElementById('bis-variant-ids')?.value || '').trim();
        const variantIds = raw.split(',').map(s => s.trim()).filter(Boolean).slice(0, 4);

        if (variantIds.length === 0) {
            console.warn('[BIS] No hay variantIds. Agrega el hidden #bis-variant-ids con IDs separados por coma.');
            return;
        }

        // Helper: POST BIS para una sola variante
        const subscribeVariant = async (variantId) => {
            const compositeId = `$shopify:::$default:::${variantId}`; // 👈 OBLIGATORIO: variant, no product

            const payload = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                profile: {
                    data: { type: "profile", attributes: { email } }
                },
                channels: ["EMAIL"]
                },
                relationships: {
                variant: {
                    data: { type: "catalog-variant", id: compositeId }
                }
                }
            }
            };

            const res = await fetch(
            `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`,
            {
                method: "POST",
                headers: {
                "content-type": "application/json",
                "revision": "2025-04-15"
                },
                body: JSON.stringify(payload)
            }
            );

            // Acepta 2xx como éxito; 409 = ya estaba suscrito → lo tomamos como OK
            if (!res.ok && res.status !== 409) {
            const text = await res.text().catch(()=> '');
            throw new Error(`[BIS] ${res.status} ${text}`);
            }
            return true;
        };

        try {
            // 🔁 dispara N requests en paralelo (hasta 4)
            const results = await Promise.allSettled(variantIds.map(subscribeVariant));

            // Revisa si al menos 1 tuvo éxito (fulfilled) o 409 tratado como OK en helper
            const someOk = results.some(r => r.status === 'fulfilled');
            if (!someOk) throw new Error('Todas las suscripciones BIS fallaron');

            // ✅ Éxito: muestra toast, cierra panel y oculta toast a los 3 s
            toast.hidden = false;
            toast.classList.add('is-visible');

            // cierra el panel de inmediato (como definiste el comportamiento)
            closeModal();

            setTimeout(() => {
            toast.classList.remove('is-visible');
            toast.hidden = true;
            }, 3000);

            form.reset();
        } catch (err) {
            console.error('Klaviyo BIS error:', err);
            // Puedes mostrar un mensaje de error si quieres
            closeModal();
        }
    });
});
